/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

export type LoginBodiesAuthFlow = typeof LoginBodiesAuthFlow[keyof typeof LoginBodiesAuthFlow];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LoginBodiesAuthFlow = {
  USER_PASSWORD_AUTH: 'USER_PASSWORD_AUTH',
  REFRESH_TOKEN_AUTH: 'REFRESH_TOKEN_AUTH',
  CUSTOM_AUTH: 'CUSTOM_AUTH',
} as const;
